import { useEffect, useMemo, useState } from 'react';
import { notification } from 'tea-component';
import { useDebounceFn, useDeepCompareEffect } from 'ahooks';
import {
  deleteFilterSaveValue,
  deleteFilterSaveSelectedValue,
  setFilterSaveSelectedValue,
} from '@gp/utils/utils';
import { isEmpty } from 'lodash-es';
import {
  addFilterSave,
  editFilterSave,
  getFilterSaveList,
  deleteFilterSave,
} from '@gp/services/filter';
import { getSaveValue } from '@gp/components/FilterCommon/components/FilterSave/util';

const useSaveInput = (props: any) => {
  const {
    value,
    handleChange,
    selectedValue,
    setSelectedValue,
    fields,
    // currentPage,
  } = props;

  // 最新方案，全部页面使用同一套保存方案page
  const currentPage = 'g_pop_common_page';
  const [filterModalInfo, setFilterModalInfo] = useState({
    filterModalType: '',
    filterModalVisible: false,
  });
  const [saveFilterValue, setSaveFilterValue] = useState<any>({});
  const [filterSaveList, setFilterSaveList] = useState<any>([]);
  const [isOperatMyFilter, setIsOperatMyFilter] = useState(true);
  const successText = 'Operate Successfully';
  const failureText = 'Operation Failure';

  // 应用筛选器保存方案
  const filterSaveChange = (valObj: any) => {
    const filterValue = valObj?.filter_value || {};
    const saveFilterValue = {
      id: valObj?.id || '',
      name: valObj?.name || '',
    };
    setSelectedValue(saveFilterValue);
    const saveValueFilter = getSaveValue(value, filterValue, fields);
    // 保存筛选器方案缓存值
    setSaveFilterValue(filterValue);

    handleChange({ ...value, ...saveValueFilter });
    setIsOperatMyFilter(true);
  };

  // 筛选器方案保存
  const addFilterSaveListFetch = async (paramsValue: any) => {
    try {
      const newParams = {
        ...paramsValue,
        page: currentPage,
      };
      await addFilterSave(newParams);
      // 更新方案列表
      getFilterSaveListFetch();
      // 提示
      notification.success({
        description: successText,
        className: 'filter-lock-alert',
        duration: 3000,
      });
      // callback?.();
    } catch (error) {
      notification.error({
        description: failureText,
        className: 'filter-lock-alert',
        duration: 3000,
      });
    }
  };

  // 筛选器方案获取列表
  const getFilterSaveListFetch = async () => {
    try {
      const results: any = await getFilterSaveList({ page: currentPage });
      const saveList = Array.isArray(results) ? results : [];
      setFilterSaveList(saveList);
    } catch (error) {}
  };

  // 筛选器方案编辑
  const editFilterSaveFetch = async (paramsValue: any, callback: () => void) => {
    const newParams = {
      ...paramsValue,
      page: currentPage,
    };
    const { name: filterName, id } = newParams || {};
    try {
      const filterNameList = filterSaveList?.map((item: any) => item?.name?.trim() || '');
      const isHaveSameName = filterNameList?.includes(filterName?.trim());
      await editFilterSave(newParams);
      // 更新方案列表
      getFilterSaveListFetch();

      // 如果编辑的是正在应用的方案，更新选中值与方案名称
      if (selectedValue?.id === id) {
        const newValue = newParams?.filter_value || {};
        const saveValueFilter = getSaveValue(value, newValue, fields);
        handleChange(saveValueFilter);
        const newSelectedValue = {
          id: newParams?.id || '',
          name: newParams?.name || '',
        };
        setSelectedValue(newSelectedValue);
        setFilterSaveSelectedValue(newSelectedValue);

        // 保存筛选器方案缓存值
        setSaveFilterValue(newValue);
      }
      // 提示
      notification.success({
        description: isHaveSameName ? `${filterName} Filter setting has updated` : successText,
        className: isHaveSameName ? 'filter-lock-alert-same-name' : 'filter-lock-alert',
        duration: 3000,
      });
      callback?.();
    } catch (error) {
      notification.error({
        description: failureText,
        className: 'filter-lock-alert',
        duration: 3000,
      });
    }
  };

  // 筛选器方案删除
  const deleteFilterSaveFetch = async (params: any, callback: () => void) => {
    const { id } = params || {};
    try {
      await deleteFilterSave({
        id,
        page: currentPage,
      });
      if (id === selectedValue?.id) {
        setSelectedValue({});
        setSaveFilterValue({});
        deleteFilterSaveValue();
        deleteFilterSaveSelectedValue();
      }
      // 更新方案列表
      getFilterSaveListFetch();
      notification.success({
        description: successText,
        className: 'filter-lock-alert',
        duration: 3000,
      });
      callback?.();
    } catch (error) {
      notification.error({
        description: failureText,
        className: 'filter-lock-alert',
        duration: 3000,
      });
    }
  };

  useEffect(() => {
    getFilterSaveListFetch();
  }, []);

  return {
    filterSaveChange,
    addFilterSaveListFetch,
    editFilterSaveFetch,
    deleteFilterSaveFetch,
    selectedValue,
    filterModalInfo,
    setFilterModalInfo,
    filterSaveList,
    getFilterSaveListFetch,
    saveFilterValue,
    setSelectedValue,
    isOperatMyFilter,
    setIsOperatMyFilter,
  };
};

export default useSaveInput;
